import { GETTEXT_ALL_FACILITIES } from '@/shared/lib';
import _ from 'lodash';

/**
 * Turns the raw support facilities into options for the page-header facility picker. Maps each facility name and id to label and value alongside canViewFlaggedStudies, status, programs and canUseIcor, orders them by label ascending, and prepends an all-facilities entry when more than one facility is supported.
 *
 * @param supportFacilities - The support facilities available to the user.
 * @returns The label-sorted facility options.
 */
const handleFormatSupportFacilites = (supportFacilities: any) => {
  /**
   * The support facilities mapped to picker options and ordered by label ascending. Each entry keeps the facility name and id as label and value alongside canViewFlaggedStudies, status, programs and canUseIcor.
   *
   * @returns The label-sorted list of facility options.
   */
  const formattedSupportFacilities = _.orderBy(
    _.map(supportFacilities, (supportFacility) => ({
      label: supportFacility.name,
      value: supportFacility.id,
      canViewFlaggedStudies: supportFacility.canViewFlaggedStudies,
      status: supportFacility.status,
      programs: supportFacility.programs,
      canUseIcor: supportFacility.canUseIcor,
    })),
    ['label'],
    ['asc'],
  );
  if (supportFacilities?.length > 1) {
    formattedSupportFacilities.unshift({
      label: GETTEXT_ALL_FACILITIES,
      value: 'All facilities',
    } as any);
  }
  return formattedSupportFacilities;
};

export { handleFormatSupportFacilites };
